import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';

import { FeedPostData, PostsFeedNewsData } from '@app/gen/dashboard';

import { FeedNewsDataType, FeedPostDataType } from '../../types';

@injectable()
export class PostsFeedMapper {
  constructor(private format: FormatService) {}

  proccessFeed(
    posts: (FeedPostData | PostsFeedNewsData)[],
  ): (FeedPostDataType | FeedNewsDataType)[] {
    return posts.map((post) =>
      post.type === 'post'
        ? {
            type: post.type,
            id: post.id,
            community: post.community,
            title: post.title,
            contentType: post.content_type,
            commentsEnabled: post.comments_enabled,
            reactionsEnabled: post.reactions_enabled,
            tags: post.tags,
            createdAt: this.format.toDateFullMonthTime(post.created_at),
            inFavorites: post.in_favorites ?? false,
            ...(post.cover_attachment_id
              ? { coverAttachmentId: post.cover_attachment_id }
              : {}),
            ...(post.summary ? { summary: post.summary } : {}),
            ...(post.content ? { content: post.content } : {}),
            ...(post.author ? { author: post.author } : {}),
            ...(post.published_at
              ? {
                  publishedAt: this.format.toDateFullMonthTime(
                    post.published_at,
                  ),
                }
              : {}),
            ...(post.edited_by ? { editedBy: post.edited_by } : {}),
            ...(post.reactions ? { reactions: post.reactions } : {}),
            ...(post.comments_num ? { commentsNum: post.comments_num } : {}),
            ...(post.views_num ? { viewsNum: post.views_num } : {}),
            ...(post.is_pinned_in_feed
              ? { isPinnedInFeed: post.is_pinned_in_feed }
              : {}),
            ...(post.actions ? { actions: post.actions } : {}),
          }
        : {
            type: post.type,
            id: post.id,
            account: post.account,
            title: post.title,
            announcement: post.announcement,
            coverAttId: post.cover_att_id,
            category: post.category,
            tags: post.tags,
            content: post.content,
            activityInfo: post.activity_info,
            isImportant: post.is_important,
            commentsEnabled: post.comments_enabled,
            reactionsEnabled: post.reactions_enabled,
            publishedAt: this.format.toDateFullMonthTime(post.published_at),
            inFavorites: post.in_favorites ?? false,
            ...(post.author ? { author: post.author } : {}),
            ...(post.reactions ? { reactions: post.reactions } : {}),
            ...(post.is_pinned_in_feed
              ? { isPinnedInFeed: post.is_pinned_in_feed }
              : {}),
            ...(post.actions ? { actions: post.actions } : {}),
          },
    );
  }
}
